document.addEventListener('DOMContentLoaded', function () {
  // Product elements
  const thumbnails = document.querySelectorAll(".product__image");
  const variants = document.querySelectorAll(".variant__container");
  const featuredImage = document.querySelector(".product__featured-image img");
  const priceElement = document.querySelector(".product__price--regular");
  const compareAtPriceElement = document.querySelector(".product__compare-at-price");
  const stockContainer = document.querySelector('[data-variant-inventory]');
  const purchaseButton = document.querySelector('.product-form .purchase-btn');
  
  var variantIdInput = document.querySelector('.variant-id-input');

  // Store initial stock icons HTML for reuse
  const initialInStockIcon = stockContainer?.querySelector('.in-stock .stock-icon')?.outerHTML || '';
  const initialOutOfStockIcon = stockContainer?.querySelector('.out-of-stock .stock-icon')?.outerHTML || '';
  const inStockColor = stockContainer?.querySelector('.in-stock span')?.style.color || '#2E7D32';
  const outOfStockColor = stockContainer?.querySelector('.out-of-stock span')?.style.color || '#C62828';
  
  // Initialize purchase button state based on initial product availability
  if (purchaseButton) {
    const initialAvailability = purchaseButton.dataset.variantAvailable === 'true';
    purchaseButton.dataset.variantAvailable = initialAvailability ? 'true' : 'false';
  }

  function updatePrice(variant) {
    const variantPrice = variant.dataset.variantPrice;
    const variantComparePrice = variant.dataset.variantComparePrice;
    const variantOriginalPrice = variant.dataset.variantOriginalPrice;
    const variantMetafieldText = variant.dataset.variantMetafieldText;
    const variantUnitPrice = variant.dataset.variantUnitPrice;
    const variantUnitMeasurement = variant.dataset.variantUnitMeasurement;

    // Check if discount is active using helper functions
    const isDiscountActiveFlag = window.pahlowmediaDiscountHelpers ? 
      window.pahlowmediaDiscountHelpers.isDiscountActive() : false;

    // Get discount percentage
    const discountPercentage = window.pahlowmediaDiscountHelpers ? 
      window.pahlowmediaDiscountHelpers.getDiscountPercentage() : 0;
    
    // Update prices based on discount status
    const regularPriceElement = document.querySelector('.product__price--regular');
    const discountedPriceElement = document.querySelector('.product__price--discounted');
    
    if (isDiscountActiveFlag && discountPercentage > 0 && variantOriginalPrice) {
      // Calculate discounted price
      const originalPriceValue = parseFloat(variantOriginalPrice);
      const discountedPrice = originalPriceValue * (1 - discountPercentage / 100);
      
      // Format the discounted price as currency
      const formattedDiscountedPrice = new Intl.NumberFormat(window.ysCurrencyLocale, {
        style: 'currency',
        currency: window.ysCurrencyCode
      }).format(discountedPrice / 100); // Shopify prices are in cents
      
      // Show discounted price as main price
      if (discountedPriceElement) {
        discountedPriceElement.textContent = formattedDiscountedPrice;
        discountedPriceElement.style.display = 'inline';
      }
      
      // Show original price as compare price (crossed out)
      if (regularPriceElement) {
        regularPriceElement.textContent = variantPrice;
        regularPriceElement.classList.add('discount-active');
      }
      
      // Hide the regular compare price when discount is active
      if (compareAtPriceElement) {
        compareAtPriceElement.classList.add('discount-active');
      }
      
    } else {
      // No discount active - show normal pricing
      if (regularPriceElement && variantPrice) {
        regularPriceElement.textContent = variantPrice;
        regularPriceElement.classList.remove('discount-active');
      }
      
      if (discountedPriceElement) {
        discountedPriceElement.style.display = 'none';
      }
      
      // Update compare at price normally
      if (compareAtPriceElement) {
        compareAtPriceElement.classList.remove('discount-active');
        if (variantComparePrice && variantComparePrice !== 'null') {
          compareAtPriceElement.textContent = variantComparePrice;
          compareAtPriceElement.style.display = "block";
        } else {
          compareAtPriceElement.style.display = "none";
        }
      }
    }
    
   
    // Update volume and unit price
    const unitPriceWrapper = document.querySelector('[data-unit-price-wrapper]');
    const unitPriceElement = document.querySelector('[data-unit-price]');

    const volumeValue = Number(
      (variant.dataset.variantVolumeValue || '').replace(',', '.')
    );
    const volumeUnit = (variant.dataset.variantVolumeUnit || '').toLowerCase();

    const referenceValue = Number(
      (variant.dataset.variantUnitReferenceValue || '').replace(',', '.')
    );
    const referenceUnit = (variantUnitMeasurement || '').toLowerCase();

    const hasNativeUnitPrice = Boolean(
      unitPriceWrapper &&
      variantUnitPrice &&
      volumeValue > 0 &&
      volumeUnit &&
      referenceValue > 0 &&
      referenceUnit
    );

    const formatQuantity = value =>
      new Intl.NumberFormat('de-DE', {
        maximumFractionDigits: 6
      }).format(value);

    if (unitPriceWrapper && unitPriceElement) {
      if (hasNativeUnitPrice) {
        const volume = `${formatQuantity(volumeValue)} ${volumeUnit}`;
        const reference = referenceValue === 1
          ? referenceUnit
          : `${formatQuantity(referenceValue)}${referenceUnit}`;

        unitPriceElement.textContent =
          `${volume} · ${variantUnitPrice}/${reference}`;

        unitPriceWrapper.style.display = '';
      } else {
        unitPriceElement.textContent = '';
        unitPriceWrapper.style.display = 'none';
      }
    }

    // Preserve legacy metafields until native measurements are entered
    const priceTextElement = document.querySelector('.product__price-text');

    if (priceTextElement) {
      if (hasNativeUnitPrice) {
        // Avoid displaying the old manually entered unit price as well
        priceTextElement.style.display = 'none';
      } else if (variantMetafieldText) {
        priceTextElement.textContent = variantMetafieldText;
        priceTextElement.style.display = '';
      } else {
        priceTextElement.style.display = 'none';
      }
    }

  }

  function changeFeaturedImage(element, isVariant = false) {
   
    let targetSrc, targetSrcset, targetAlt;
    
    if (isVariant) {
      targetSrc = element.dataset.variantImage;
      targetSrcset = element.dataset.variantImageSrcset;
      targetAlt = element.dataset.variantImageAlt;
   
      
      // If variant doesn't have an image, don't try to update
      if (!targetSrc || targetSrc === 'null' || targetSrc === '') {
      
        return;
      }
    } else {
      const img = element.querySelector("img");
      if (!img) {
       
        return;
      }
      targetSrc = img.src;
      targetSrcset = img.srcset;
      targetAlt = img.alt;
      
    }

    // Update desktop featured image
    if (featuredImage && targetSrc) {
      featuredImage.src = targetSrc;
      if (targetSrcset) featuredImage.srcset = targetSrcset;
      if (targetAlt) featuredImage.alt = targetAlt;
     
    }

    // Update carousel image for all screen sizes
    if (targetSrc) {
      updateCarouselActiveImage(targetSrc);
    }
  }

  // Helper function to check if we're in mobile/tablet mode
  function isMobileTabletMode() {
    return window.innerWidth <= 1024;
  }

  // Function to update active image in carousel
  function updateCarouselActiveImage(targetSrc) {
   
    
    const allProductImages = document.querySelectorAll('.product__image');
    const imageCounter = document.querySelector('.image-counter');
    const currentImageSpan = imageCounter ? imageCounter.querySelector('.current-image') : null;
    
   
    
    // Function to normalize image URL for comparison (remove size parameters)
    function normalizeImageUrl(url) {
      if (!url) return '';
      // Remove size parameters like _1600x.jpg, _640x.jpg etc.
      return url.replace(/_\d+x\d*\.(jpg|jpeg|png|webp|gif)/i, '.$1')
                .replace(/\?.*$/, ''); // Remove query parameters
    }
    
    const normalizedTargetSrc = normalizeImageUrl(targetSrc);
    
    
    // Find the matching image in the product images carousel
    let matchingIndex = -1;
    allProductImages.forEach((productImage, index) => {
      const img = productImage.querySelector('img');
      if (img) {
        const normalizedImgSrc = normalizeImageUrl(img.src);
        
        if (normalizedImgSrc === normalizedTargetSrc) {
          matchingIndex = index;
          
        }
      }
    });

    // If we couldn't find an exact match, try a more lenient approach
    if (matchingIndex === -1) {
    
      allProductImages.forEach((productImage, index) => {
        const img = productImage.querySelector('img');
        if (img) {
          const imgSrc = img.src;
          const imgOriginalSrc = img.getAttribute('src');
          
          
          if (imgSrc === targetSrc || 
              targetSrc.includes(imgOriginalSrc) || 
              imgSrc.includes(targetSrc.split('/').pop()) ||
              normalizeImageUrl(imgSrc).includes(normalizeImageUrl(targetSrc).split('/').pop())) {
            matchingIndex = index;
            
          }
        }
      });
    }

    // If we found a matching image, make it active
    if (matchingIndex !== -1) {
     
      allProductImages.forEach((productImage, index) => {
        if (index === matchingIndex) {
          productImage.classList.add('active');
        } else {
          productImage.classList.remove('active');
        }
      });

      // Update counter
      if (currentImageSpan) {
        currentImageSpan.textContent = matchingIndex + 1;
      }
    } else {
      
      // If no match found, activate the first image as fallback
      if (allProductImages.length > 0) {
        allProductImages[0].classList.add('active');
        if (currentImageSpan) {
          currentImageSpan.textContent = '1';
        }
      }
    }
  }

  function clearActiveStates() {
    variants.forEach((v) => {
      const variantImg = v.querySelector("img");
      variantImg.classList.remove("active-variant-img");
      v.classList.remove("active-variant");
    });
    thumbnails.forEach((t) => {
      const thumbnailImg = t.querySelector("img");
      thumbnailImg.classList.remove("active-thumbnail");
    });
    
    // Clear active states from mobile/tablet carousel images
    const allProductImages = document.querySelectorAll('.product__image');
    allProductImages.forEach((productImage) => {
      productImage.classList.remove('active');
    });
  }

  // Function to update stock status
  function updateStockStatus(variantId) {
    const selectedVariant = document.querySelector(`.variant__container[data-variant-id="${variantId}"]`);
    if (!selectedVariant || !stockContainer) return;

    // Check if product is a gift card
    const isGiftCard = stockContainer.dataset.isGiftCard === 'true';

    // Preserve existing delivery message content
    const existingDeliveryMessage = document.getElementById('delivery-message');
    const deliveryText = existingDeliveryMessage ? existingDeliveryMessage.innerHTML : '';
    
    

    // Parse the available value, ensuring it's truly a boolean result
    const isAvailable = selectedVariant.dataset.variantAvailable.toLowerCase() === 'true';

    if (isAvailable) {
      // Conditionally include delivery message only if not a gift card
      const deliveryMessageHtml = isGiftCard
        ? 'Keine Lieferungszeit'
        : `<span id="delivery-message" data-in-stock-color="${inStockColor}">${deliveryText}</span>`;
      stockContainer.innerHTML = `
        <div class="stock-status in-stock">
          ${initialInStockIcon}
          <span style="color: ${inStockColor}">${deliveryMessageHtml}</span>
        </div>
      `;
      // Enable add to cart button
      if (purchaseButton) {
        purchaseButton.dataset.variantAvailable = 'true';
      }
    } else {
      stockContainer.innerHTML = `
        <div class="stock-status out-of-stock">
          ${initialOutOfStockIcon}
          <span style="color: ${outOfStockColor}">Ausverkauft</span>
        </div>
      `;
      // Disable add to cart button
      if (purchaseButton) {
        purchaseButton.dataset.variantAvailable = 'false';
      }
    }
    
    // Trigger delivery time update if the delivery script is available
    if (window.updateDeliveryTime && typeof window.updateDeliveryTime === 'function') {
      
      window.updateDeliveryTime();
    }
  }

  // Function to update variant form input
  function updateVariantFormInput(variantId) {
   
    if (variantIdInput) {
      var oldValue = variantIdInput.value;
      variantIdInput.value = variantId;
     
      
      // Trigger change event to ensure other scripts know about the update
      const changeEvent = new Event('change', { bubbles: true });
      variantIdInput.dispatchEvent(changeEvent);
    } else {
      
    }
  }

  // Enhanced image matching function for better src-based matching
  function findVariantByEnhancedImageMatching(imageSrc) {
    
    
    // Function to normalize image URL for comparison
    function normalizeImageUrl(url) {
      if (!url) return '';
      return url.replace(/_\d+x\d*\.(jpg|jpeg|png|webp|gif)/i, '.$1')
                .replace(/\?.*$/, '')
                .replace(/^https?:\/\/[^\/]+/, '');
    }
    
    // Function to get filename from URL
    function getImageFilename(url) {
      if (!url) return '';
      return url.split('/').pop().split('?')[0];
    }
    
    // Function to get base filename without size parameters
    function getBaseFilename(url) {
      if (!url) return '';
      const filename = getImageFilename(url);
      return filename.replace(/_\d+x\d*\.(jpg|jpeg|png|webp|gif)/i, '.$1');
    }
    
    const normalizedImageSrc = normalizeImageUrl(imageSrc);
    const imageFilename = getImageFilename(imageSrc);
    const baseImageFilename = getBaseFilename(imageSrc);
    
    
    
    // Try different matching approaches
    for (let i = 0; i < variants.length; i++) {
      const variant = variants[i];
      const variantImageSrc = variant.dataset.variantImage;
      
      if (!variantImageSrc || variantImageSrc === 'null' || variantImageSrc === '') {
        continue;
      }
      
      const normalizedVariantSrc = normalizeImageUrl(variantImageSrc);
      const variantFilename = getImageFilename(variantImageSrc);
      const baseVariantFilename = getBaseFilename(variantImageSrc);
      
      
      
      // Approach 1: Exact normalized match
      if (normalizedImageSrc === normalizedVariantSrc) {
        
        return variant;
      }
      
      // Approach 2: Base filename match
      if (baseImageFilename && baseVariantFilename && baseImageFilename === baseVariantFilename) {
        
        return variant;
      }
      
      // Approach 3: Filename contains variant filename or vice versa
      if (imageFilename && variantFilename) {
        if (imageFilename.includes(variantFilename) || variantFilename.includes(imageFilename)) {
          
          return variant;
        }
      }
      
      // Approach 4: URL contains the other URL
      if (imageSrc.includes(variantImageSrc) || variantImageSrc.includes(imageSrc)) {
        
        return variant;
      }
    }
    
    
    return null;
  }

  // Function to verify form variant sync and fix discrepancies
  function verifyFormVariantSync() {
    const activeVariant = document.querySelector('.variant__container.active-variant');
    const formVariantId = variantIdInput?.value;
    
    if (activeVariant) {
      const activeVariantId = activeVariant.dataset.variantId;
      
      
      if (activeVariantId !== formVariantId) {
        
        updateVariantFormInput(activeVariantId);
      } else {
        
      }
    } else {
      
      if (variants.length > 0) {
        const firstVariant = variants[0];
        const variantId = firstVariant.dataset.variantId;
        
        
        // Clear all and set first as active
        variants.forEach((v) => {
          const variantImg = v.querySelector("img");
          if (variantImg) {
            variantImg.classList.remove("active-variant-img");
          }
          v.classList.remove("active-variant");
        });
        
        const firstVariantImg = firstVariant.querySelector("img");
        if (firstVariantImg) {
          firstVariantImg.classList.add("active-variant-img");
        }
        firstVariant.classList.add("active-variant");
        
        updatePrice(firstVariant);
        updateStockStatus(variantId);
        updateVariantFormInput(variantId);
      }
    }
  }

  // Respect the linked variant and the selection rendered by Liquid
  if (variants.length > 0) {
    const variantList = Array.from(variants);
    const linkedVariantId = new URLSearchParams(
      window.location.search
    ).get('variant');

    const firstVariant =
      variantList.find(v => v.dataset.variantId === linkedVariantId) ||
      variantList.find(v => v.classList.contains('active-variant')) ||
      variantList.find(v => v.dataset.variantId === variantIdInput?.value) ||
      variantList.find(v => v.dataset.variantAvailable === 'true') ||
      variantList[0];

    // Clear previous highlights before activating the selected variant
    variants.forEach(v => {
      v.classList.remove('active-variant');
      v.querySelector('img')?.classList.remove('active-variant-img');
    });

    thumbnails.forEach(t => {
      t.querySelector('img')?.classList.remove('active-thumbnail');
    });

    const firstVariantImg = firstVariant.querySelector('img');

    firstVariantImg?.classList.add('active-variant-img');
    firstVariant.classList.add('active-variant');
    
    // Update the featured image to match the first variant
    changeFeaturedImage(firstVariant, true);
    
    // Update price and stock for the first variant
    updatePrice(firstVariant);
    const variantId = firstVariant.dataset.variantId;
    updateStockStatus(variantId);
    updateVariantFormInput(variantId);
    
    // Ensure the first variant is visible in the carousel
    if (window.ensureActiveVariantVisible) {
      setTimeout(() => {
        window.ensureActiveVariantVisible();
      }, 200); // Delay to ensure slider is initialized
    }
    
    // Also activate the corresponding thumbnail if it exists
    const firstVariantImageSrc = firstVariant.dataset.variantImage;
    if (firstVariantImageSrc && firstVariantImageSrc !== 'null' && firstVariantImageSrc !== '') {
      
      // Function to normalize image URL for comparison
      function normalizeImageUrl(url) {
        if (!url) return '';
        return url.replace(/_\d+x\d*\.(jpg|jpeg|png|webp|gif)/i, '.$1')
                  .replace(/\?.*$/, '');
      }
      
      const normalizedVariantSrc = normalizeImageUrl(firstVariantImageSrc);
      
      thumbnails.forEach((thumbnail) => {
        const thumbnailImg = thumbnail.querySelector("img");
        if (thumbnailImg) {
          const normalizedThumbnailSrc = normalizeImageUrl(thumbnailImg.src);
          if (normalizedThumbnailSrc === normalizedVariantSrc) {
            thumbnailImg.classList.add("active-thumbnail");
          }
        }
      });
    }
  }

  // Function to find and activate matching variant based on image source
  function findAndActivateMatchingVariant(thumbnailImgSrc) {
    
    
    // Function to normalize image URL for comparison
    function normalizeImageUrl(url) {
      if (!url) return '';
      // Remove size parameters like _1600x.jpg, _640x.jpg etc.
      const normalized = url.replace(/_\d+x\d*\.(jpg|jpeg|png|webp|gif)/i, '.$1')
                           .replace(/\?.*$/, '') // Remove query parameters
                           .replace(/^https?:\/\/[^\/]+/, ''); // Remove domain for comparison
     
      return normalized;
    }
    
    // Function to get filename for better matching
    function getFilename(url) {
      if (!url) return '';
      return url.split('/').pop().split('?')[0];
    }
    
    const normalizedThumbnailSrc = normalizeImageUrl(thumbnailImgSrc);
    
    
    // Debug: Log all variant images
    variants.forEach((variant, index) => {
      const variantImageSrc = variant.dataset.variantImage;
      
    });
    
    // Find matching variant with enhanced matching
    let matchingVariant = null;
    const thumbnailFilename = getFilename(thumbnailImgSrc);
    const thumbnailBaseFilename = thumbnailFilename.replace(/_\d+x\d*\.(jpg|jpeg|png|webp|gif)/i, '.$1');
    
    
    
    variants.forEach((variant, index) => {
      const variantImageSrc = variant.dataset.variantImage;
      if (variantImageSrc && variantImageSrc !== 'null' && variantImageSrc !== '') {
        const normalizedVariantSrc = normalizeImageUrl(variantImageSrc);
        const variantFilename = getFilename(variantImageSrc);
        const variantBaseFilename = variantFilename.replace(/_\d+x\d*\.(jpg|jpeg|png|webp|gif)/i, '.$1');
        
        
        
        // Approach 1: Exact normalized match
        if (normalizedVariantSrc === normalizedThumbnailSrc) {
          matchingVariant = variant;
          return;
        }
        
        // Approach 2: Base filename match (most reliable for different sizes)
        if (thumbnailBaseFilename && variantBaseFilename && thumbnailBaseFilename === variantBaseFilename) {
          matchingVariant = variant;
          return;
        }
        
        // Approach 3: Full filename match
        if (thumbnailFilename && variantFilename && thumbnailFilename === variantFilename) {
          matchingVariant = variant;
          return;
        }
        
        // Approach 4: Filename inclusion
        if (thumbnailFilename && variantFilename) {
          if (thumbnailFilename.includes(variantFilename) || variantFilename.includes(thumbnailFilename)) {
            matchingVariant = variant;
            return;
          }
        }
        
        // Approach 5: URL inclusion (least reliable)
        if (normalizedThumbnailSrc.includes(normalizedVariantSrc) || 
            normalizedVariantSrc.includes(normalizedThumbnailSrc)) {
          matchingVariant = variant;
          return;
        }
      }
    });
    
    // Store currently active variant before clearing (for fallback)
    let currentlyActiveVariant = null;
    variants.forEach((v) => {
      if (v.classList.contains("active-variant")) {
        currentlyActiveVariant = v;
      }
    });
    
    // If matching variant found, activate it
    if (matchingVariant) {
      
      // Clear all variant active states
      variants.forEach((v) => {
        const variantImg = v.querySelector("img");
        if (variantImg) {
          variantImg.classList.remove("active-variant-img");
        }
        v.classList.remove("active-variant");
      });
      
      // Activate matching variant
      const variantImg = matchingVariant.querySelector("img");
      if (variantImg) {
        variantImg.classList.add("active-variant-img");
      }
      matchingVariant.classList.add("active-variant");
      
      // Update price, stock, and variant form
      updatePrice(matchingVariant);
      const variantId = matchingVariant.dataset.variantId;
      updateStockStatus(variantId);
      updateVariantFormInput(variantId);
      
      
      // Ensure the active variant is visible in the carousel
      if (window.ensureActiveVariantVisible) {
        window.ensureActiveVariantVisible();
      }
      
      return true; // Found and activated
    } else {
      
      // Fallback: Keep the previously active variant active
      if (currentlyActiveVariant) {
        
        // Ensure the previously active variant remains active
        const variantImg = currentlyActiveVariant.querySelector("img");
        if (variantImg) {
          variantImg.classList.add("active-variant-img");
        }
        currentlyActiveVariant.classList.add("active-variant");
        
        // Ensure the preserved variant is visible in the carousel
        if (window.ensureActiveVariantVisible) {
          window.ensureActiveVariantVisible();
        }
        
        // Keep the current variant's price, stock, and form data (no update needed)
      } else {
        
        // If no variant was previously active, fall back to first variant
        if (variants.length > 0) {
          const firstVariant = variants[0];
          const variantImg = firstVariant.querySelector("img");
          if (variantImg) {
            variantImg.classList.add("active-variant-img");
          }
          firstVariant.classList.add("active-variant");
          
          // Update price, stock, and variant form to first variant
          updatePrice(firstVariant);
          const variantId = firstVariant.dataset.variantId;
          updateStockStatus(variantId);
          updateVariantFormInput(variantId);
          
          // Ensure the first variant is visible in the carousel
          if (window.ensureActiveVariantVisible) {
            window.ensureActiveVariantVisible();
          }
        }
      }
      
      return false; // No matching variant found
    }
  }

  // Clicking on a thumbnail
  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener("click", function () {
      
      
      // Only allow thumbnail clicks on desktop mode
      if (!isMobileTabletMode()) {
        // Clear only thumbnail and product image active states (preserve variant states for now)
        thumbnails.forEach((t) => {
          const thumbnailImg = t.querySelector("img");
          if (thumbnailImg) {
            thumbnailImg.classList.remove("active-thumbnail");
          }
        });
        
        // Clear active states from mobile/tablet carousel images
        const allProductImages = document.querySelectorAll('.product__image');
        allProductImages.forEach((productImage) => {
          productImage.classList.remove('active');
        });
        
        const thumbnailImg = this.querySelector("img");
        
        if (!thumbnailImg) {
          return;
        }
        
        thumbnailImg.classList.add("active-thumbnail");
        changeFeaturedImage(this, false);
        
        // Check for matching variant and activate it
        const thumbnailImgSrc = thumbnailImg.src;
        
        if (variants.length === 0) {
          return;
        }
        
        // Force sync variant with clicked thumbnail image src
        activateVariantForActiveImage(thumbnailImgSrc);
      } else {
      }
    });
  });

  // Clicking on a variant
  variants.forEach((variant) => {
    variant.addEventListener("click", function () {
      
      clearActiveStates();
      const variantImg = this.querySelector("img");
      variantImg.classList.add("active-variant-img");
      this.classList.add("active-variant");
      
      changeFeaturedImage(this, true);
      updatePrice(this);
      const variantId = this.dataset.variantId;
      updateStockStatus(variantId);
      updateVariantFormInput(variantId);
      
      // Dispatch event to sync with product media gallery
      const variantSelectedEvent = new CustomEvent('variantSelected', {
        detail: {
          variantId: variantId,
          variantImage: this.dataset.variantImage
        }
      });
      document.dispatchEvent(variantSelectedEvent);
      
      // Ensure the active variant is visible in the carousel
      if (window.ensureActiveVariantVisible) {
        setTimeout(() => {
          window.ensureActiveVariantVisible();
        }, 100);
      }
    });
  });

  // Color variant functionality
  function initializeColorVariants() {
    const colorVariantItems = document.querySelectorAll('.color-variant-item');
    const activeColorVariant = document.querySelector('.active-color-variant');
    const colorVariantSummary = document.querySelector('.color-variant-summary');
    
    if (colorVariantItems.length === 0) return;

    // Set the current product's color as active
    const currentProductHandle = window.location.pathname.split('/').pop();
    
    colorVariantItems.forEach(item => {
      const itemUrl = item.getAttribute('href');
      const itemHandle = itemUrl.split('/').pop();
      
      if (itemHandle === currentProductHandle) {
        const colorName = item.dataset.colorName;
        const colorValue = item.dataset.colorValue;
        
        if (activeColorVariant) {
          const colorSpan = activeColorVariant.querySelector('.color-variant__color');
          const nameSpan = activeColorVariant.querySelector('.color-variant__name');
          
          if (colorSpan && nameSpan) {
            colorSpan.style.backgroundColor = colorValue;
            colorSpan.classList.remove('default-color-placeholder');
            nameSpan.textContent = colorName;
          }
        }
      }
    });
  }

  // Variant slider functionality
  function initializeVariantSlider() {
    const variantContainer = document.querySelector('.product__variant-container');
    const variantSlider = document.querySelector('.variants-slider');
    const prevBtn = document.querySelector('.variant-nav.prev-btn');
    const nextBtn = document.querySelector('.variant-nav.next-btn');
    const variants = document.querySelectorAll('.variant__container');

    if (!variantContainer || !variantSlider || variants.length === 0) return;

    const mobileBreakpoint =
      parseInt(variantContainer.dataset.mobileBreakpoint, 10) || 767;
    const mobileMediaQuery = window.matchMedia(
      `(max-width: ${mobileBreakpoint}px)`
    );

    let currentStartIndex = 0;
    let visibleCount = mobileMediaQuery.matches ? 4 : 5;
    let maxStartIndex = Math.max(0, variants.length - visibleCount);
    let isUserScrolling = false;

    function updateVariantSlider() {
      visibleCount = mobileMediaQuery.matches ? 4 : 5;
      maxStartIndex = Math.max(0, variants.length - visibleCount);
      currentStartIndex = Math.min(currentStartIndex, maxStartIndex);

      // Hide all variants first
      variants.forEach((variant) => {
        variant.classList.add('hidden');
      });

      // Show the correct number of consecutive variants for this viewport
      const endIndex = Math.min(currentStartIndex + visibleCount, variants.length);

      for (let i = currentStartIndex; i < endIndex; i++) {
        if (variants[i]) {
          variants[i].classList.remove('hidden');
        }
      }

      const navigationIsNeeded = variants.length > visibleCount;

      // Update button states
      if (prevBtn) {
        prevBtn.style.display = navigationIsNeeded ? 'flex' : 'none';
        const isAtStart = currentStartIndex === 0;
        prevBtn.style.opacity = isAtStart ? '0.5' : '1';
        prevBtn.style.cursor = isAtStart ? 'not-allowed' : 'pointer';
        prevBtn.disabled = isAtStart;
      }

      if (nextBtn) {
        nextBtn.style.display = navigationIsNeeded ? 'flex' : 'none';
        const isAtEnd = currentStartIndex >= maxStartIndex;
        nextBtn.style.opacity = isAtEnd ? '0.5' : '1';
        nextBtn.style.cursor = isAtEnd ? 'not-allowed' : 'pointer';
        nextBtn.disabled = isAtEnd;
      }
    }

    // Function to ensure active variant is visible
    function ensureActiveVariantVisible(forceScroll = false) {
      if (isUserScrolling && !forceScroll) {
        return;
      }

      // Find active variant index
      let activeVariantIndex = -1;
      variants.forEach((variant, index) => {
        if (variant.classList.contains('active-variant')) {
          activeVariantIndex = index;
        }
      });

      if (activeVariantIndex === -1) {
        return;
      }

      // Check if active variant is currently visible
      const isVisible = activeVariantIndex >= currentStartIndex &&
                       activeVariantIndex < currentStartIndex + visibleCount;

      if (!isVisible || forceScroll) {
        // Calculate new start index to center the active variant if possible
        let newStartIndex = Math.max(0, activeVariantIndex - Math.floor(visibleCount / 2));
        newStartIndex = Math.min(newStartIndex, maxStartIndex);

        currentStartIndex = newStartIndex;
      }

      updateVariantSlider();
    }

    // Previous button click handler - move back by 1 variant
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (currentStartIndex > 0) {
          isUserScrolling = true;
          currentStartIndex--;
          updateVariantSlider();
          
          // Reset user scrolling flag after a short delay
          setTimeout(() => {
            isUserScrolling = false;
          }, 1000);
        }
      });
    }

    // Next button click handler - move forward by 1 variant
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (currentStartIndex < maxStartIndex) {
          isUserScrolling = true;
          currentStartIndex++;
          updateVariantSlider();
          
          // Reset user scrolling flag after a short delay
          setTimeout(() => {
            isUserScrolling = false;
          }, 1000);
        }
      });
    }

    // Recalculate the number of visible variants when crossing the mobile breakpoint
    const handleBreakpointChange = function () {
      visibleCount = mobileMediaQuery.matches ? 4 : 5;
      maxStartIndex = Math.max(0, variants.length - visibleCount);
      ensureActiveVariantVisible(true);
    };

    if (typeof mobileMediaQuery.addEventListener === 'function') {
      mobileMediaQuery.addEventListener('change', handleBreakpointChange);
    } else {
      mobileMediaQuery.addListener(handleBreakpointChange);
    }

    updateVariantSlider();

    // Make ensureActiveVariantVisible available globally with force scroll option
    window.ensureActiveVariantVisible = ensureActiveVariantVisible;
  }

  // Function to activate variant based ONLY on image src (no index-based matching)
  function activateVariantForActiveImage(imageSrc) {
    
    let selectedVariant = null;
    
    // Approach 1: Try standard image src matching
    const hasMatchingVariant = findAndActivateMatchingVariant(imageSrc);
    if (hasMatchingVariant) {
      selectedVariant = document.querySelector('.variant__container.active-variant');
    } else {
      
      // Approach 2: Try enhanced image src matching
      const enhancedMatch = findVariantByEnhancedImageMatching(imageSrc);
      if (enhancedMatch) {
        
        // Clear all variant active states
        variants.forEach((v) => {
          const variantImg = v.querySelector("img");
          if (variantImg) {
            variantImg.classList.remove("active-variant-img");
          }
          v.classList.remove("active-variant");
        });
        
        // Activate matched variant
        const variantImg = enhancedMatch.querySelector("img");
        if (variantImg) {
          variantImg.classList.add("active-variant-img");
        }
        enhancedMatch.classList.add("active-variant");
        
        // Update price, stock, and variant form
        updatePrice(enhancedMatch);
        const variantId = enhancedMatch.dataset.variantId;
        updateStockStatus(variantId);
        updateVariantFormInput(variantId);
        
        selectedVariant = enhancedMatch;
      } else {
        
        // Only preserve current state if there's already an active variant
        // Don't activate any variant if image src doesn't match
        const activeVariant = document.querySelector('.variant__container.active-variant');
        if (activeVariant) {
          const variantId = activeVariant.dataset.variantId;
          updateVariantFormInput(variantId);
          selectedVariant = activeVariant;
        }
      }
    }
    
    // Ensure the active variant is visible in the carousel (only if we have one)
    if (selectedVariant && window.ensureActiveVariantVisible) {
      setTimeout(() => {
        window.ensureActiveVariantVisible(true); // Force scroll
      }, 100);
    }
    
    // Verify final state
    verifyFormVariantSync();
  }

  // Mobile/Tablet image navigation functionality
  function initializeMobileImageNavigation() {
    const prevBtn = document.querySelector('.image-nav.mobile-nav.prev-btn');
    const nextBtn = document.querySelector('.image-nav.mobile-nav.next-btn');
    const allProductImages = document.querySelectorAll('.product__image');
    
    if (!prevBtn || !nextBtn || allProductImages.length <= 1) return;
    
    let currentActiveIndex = 0;
    
    // Find initially active image
    allProductImages.forEach((img, index) => {
      if (img.classList.contains('active')) {
        currentActiveIndex = index;
      }
    });
    
    // If no active image, activate first one
    if (currentActiveIndex === 0 && allProductImages.length > 0) {
      allProductImages[0].classList.add('active');
    }
    
    function updateActiveImage(newIndex) {
      // Remove active class from all images
      allProductImages.forEach(img => img.classList.remove('active'));
      
      // Add active class to new image
      if (allProductImages[newIndex]) {
        allProductImages[newIndex].classList.add('active');
        currentActiveIndex = newIndex;
        
        // Update counter
        const currentImageSpan = document.querySelector('.image-counter .current-image');
        if (currentImageSpan) {
          currentImageSpan.textContent = newIndex + 1;
        }
        
        // Force sync variant with active product image
        const activeImg = allProductImages[newIndex].querySelector('img');
        if (activeImg) {
        
          
          // Force variant activation based on current active product image src
          activateVariantForActiveImage(activeImg.src);
        }
        
        // Verify final state after all updates
        verifyFormVariantSync();
      }
    }
    
    // Previous button
    prevBtn.addEventListener('click', function() {
      const newIndex = currentActiveIndex > 0 ? currentActiveIndex - 1 : allProductImages.length - 1;
      updateActiveImage(newIndex);
    });
    
    // Next button
    nextBtn.addEventListener('click', function() {
      const newIndex = currentActiveIndex < allProductImages.length - 1 ? currentActiveIndex + 1 : 0;
      updateActiveImage(newIndex);
    });
  }

  // Desktop thumbnail navigation functionality (up/down arrows)
  function initializeDesktopThumbnailNavigation() {
    const upBtn = document.querySelector('.product-images__button.up');
    const downBtn = document.querySelector('.product-images__button.down');
    const imagesSlider = document.querySelector('.images-slider');
    const thumbnails = document.querySelectorAll('.product__image');
    
    if (!upBtn || !downBtn || !imagesSlider || thumbnails.length <= 5) return;
    
    let currentScrollIndex = 0;
    const maxScrollIndex = thumbnails.length - 5; // Show 5 thumbnails at a time
    
    function updateThumbnailSlider() {
      const translateY = currentScrollIndex * -55; // Assuming ~55px per thumbnail (50px + gap)
      imagesSlider.style.transform = `translateY(${translateY}px)`;
      
      // Update button states
      upBtn.style.opacity = currentScrollIndex === 0 ? '0.5' : '1';
      downBtn.style.opacity = currentScrollIndex >= maxScrollIndex ? '0.5' : '1';
    }
    
    upBtn.addEventListener('click', function() {
      if (currentScrollIndex > 0) {
        currentScrollIndex--;
        updateThumbnailSlider();
      }
    });
    
    downBtn.addEventListener('click', function() {
      if (currentScrollIndex < maxScrollIndex) {
        currentScrollIndex++;
        updateThumbnailSlider();
      }
    });
    
    // Initialize button states
    updateThumbnailSlider();
  }

  // Desktop featured image navigation functionality (left/right arrows)
  function initializeDesktopFeaturedImageNavigation() {
    const prevBtn = document.querySelector('.thumbnail-prev-btn');
    const nextBtn = document.querySelector('.thumbnail-next-btn');
    const allProductImages = document.querySelectorAll('.product__image');
    
    if (!prevBtn || !nextBtn || allProductImages.length <= 1) return;
    
    let currentFeaturedIndex = 0;
    
    // Find currently active thumbnail
    allProductImages.forEach((img, index) => {
      const thumbnailImg = img.querySelector('img');
      if (thumbnailImg && thumbnailImg.classList.contains('active-thumbnail')) {
        currentFeaturedIndex = index;
      }
    });
    
    function updateFeaturedImage(newIndex) {
      if (newIndex < 0 || newIndex >= allProductImages.length) return;
      
      // Clear only thumbnail and product image active states (preserve variant states)
      thumbnails.forEach((thumbnail) => {
        const thumbnailImg = thumbnail.querySelector("img");
        if (thumbnailImg) {
          thumbnailImg.classList.remove("active-thumbnail");
        }
      });
      
      const allCarouselImages = document.querySelectorAll('.product__image');
      allCarouselImages.forEach((productImage) => {
        productImage.classList.remove('active');
      });
      
      // Activate new thumbnail
      const newThumbnail = allProductImages[newIndex];
      const newThumbnailImg = newThumbnail.querySelector('img');
      if (newThumbnailImg) {
        newThumbnailImg.classList.add('active-thumbnail');
        changeFeaturedImage(newThumbnail, false);
        
        // Force sync variant with active thumbnail image src
        activateVariantForActiveImage(newThumbnailImg.src);
      }
      
      currentFeaturedIndex = newIndex;
    }
    
    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const newIndex = currentFeaturedIndex > 0 ? currentFeaturedIndex - 1 : allProductImages.length - 1;
      updateFeaturedImage(newIndex);
    });
    
    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const newIndex = currentFeaturedIndex < allProductImages.length - 1 ? currentFeaturedIndex + 1 : 0;
      updateFeaturedImage(newIndex);
    });
  }

  // Product image click functionality for mobile/tablet and direct image interactions
  function initializeProductImageClicks() {
    const allProductImages = document.querySelectorAll('.product__image');
    
      
    allProductImages.forEach((productImage, index) => {
      productImage.addEventListener('click', function(e) {
        
        const clickedImg = this.querySelector('img');
        if (!clickedImg) {
          return;
        }
        
        const clickedImgSrc = clickedImg.src;
        
        // Clear all product image active states
        allProductImages.forEach(img => img.classList.remove('active'));
        
        // Make clicked image active
        this.classList.add('active');
        
        // Update counter for mobile/tablet
        const imageCounter = document.querySelector('.image-counter');
        const currentImageSpan = imageCounter ? imageCounter.querySelector('.current-image') : null;
        if (currentImageSpan) {
          currentImageSpan.textContent = index + 1;
        }
        
        // If on desktop, also update thumbnail active state
        if (!isMobileTabletMode()) {
          thumbnails.forEach((thumbnail) => {
            const thumbnailImg = thumbnail.querySelector("img");
            if (thumbnailImg) {
              thumbnailImg.classList.remove("active-thumbnail");
            }
          });
          
          // Find matching thumbnail and activate it
          thumbnails.forEach((thumbnail) => {
            const thumbnailImg = thumbnail.querySelector("img");
            if (thumbnailImg) {
              const thumbnailSrc = thumbnailImg.src;
              if (normalizeImageUrlForMatching(thumbnailSrc) === normalizeImageUrlForMatching(clickedImgSrc)) {
                thumbnailImg.classList.add("active-thumbnail");
              }
            }
          });
          
          // Update featured image
          changeFeaturedImage(this, false);
        }
        
        // Force sync variant with clicked product image src
        activateVariantForActiveImage(clickedImgSrc);
      });
    });
  }

  // Helper function for image URL normalization in click handlers
  function normalizeImageUrlForMatching(url) {
    if (!url) return '';
    return url.replace(/_\d+x\d*\.(jpg|jpeg|png|webp|gif)/i, '.$1')
              .replace(/\?.*$/, '')
              .replace(/^https?:\/\/[^\/]+/, '');
  }

  // Listen for media selection from product media gallery to sync variant
  document.addEventListener('mediaSelected', function(e) {
    const mediaSrc = e.detail.mediaSrc;
    if (mediaSrc) {
      activateVariantForActiveImage(mediaSrc);
    }
  });

  // Initialize all functionality
  initializeColorVariants();
  initializeVariantSlider();
  initializeMobileImageNavigation();
  initializeDesktopThumbnailNavigation();
  initializeDesktopFeaturedImageNavigation();
  initializeProductImageClicks();

  // Handle window resize to maintain image consistency across screen sizes
  window.addEventListener('resize', function() {
    // Find the currently active variant
    const activeVariant = document.querySelector('.variant__container.active-variant');
    if (activeVariant) {
      // Re-apply the image change to ensure consistency
      changeFeaturedImage(activeVariant, true);
    }
  });

  // Handle form submission for variant availability check
  const addToCartForm = document.querySelector('.product-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      
      // Verify form variant sync before submission
      verifyFormVariantSync();
      
      const currentVariantId = variantIdInput?.value;
      const activeVariant = document.querySelector('.variant__container.active-variant');
      
      
      // Check if variant is available
      if (purchaseButton && purchaseButton.dataset.variantAvailable === 'false') {
        e.preventDefault();
        alert('Dieses Produkt ist derzeit nicht verfügbar.');
        return false;
      }

      // Make sure variant ID is set if no variant is selected
      if (!currentVariantId && variants.length > 0) {
        // If no variant is selected, use the first variant
        const firstVariant = variants[0];
        const firstVariantId = firstVariant.dataset.variantId;
        if (variantIdInput) {
          variantIdInput.value = firstVariantId;
        }
      }
      
      // Final verification
      const finalVariantId = variantIdInput?.value;
    });
  }
});
